import React, { Component, Fragment } from 'react'
import axios from 'axios'
import swal from 'sweetalert'
import { connect } from 'react-redux'
import { Button, FormControl, Row, Col, Overlay, Popover } from 'react-bootstrap'
import { editMetadata } from '../../projects/reducers/manageProjects'
import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

import DuplicateMetadataModal from './DuplicateMetadataModal'

class EditMetadataType extends Component {
  state = {
    selectedMetadata: '',
    updatedMetadataName: '',
    updatedMetadataAlreadyExists: false,
    metadataThatAlreadyExists: null,
    updatedMetadataIsExactDuplicate: false,
  }

  toggleShowDeletePopover = () => {
    this.setState({ showDeletePopover: !this.state.showDeletePopover})
  }

  handleChange = (event) => this.setState({ [event.target.name]: event.target.value })

  handleSelect = (event) => {
    const { metadata } = this.props
    const index = event.target.value
    if (index === '') {
      this.setState({
        selectedMetadata: '',
        updatedMetadataName: ''
      })
    } else {
      this.setState({
        selectedMetadata: metadata[event.target.value],
        updatedMetadataName: metadata[event.target.value].name
      })
    }
  }


  checkIfMetadataExists = () => {
    if (!this.state.updatedMetadataName) {
      return swal({
        title: "Error",
        text: "Please enter a metadata type before saving",
        icon: "error",
        button: "Continue",
      })
    }

    const exactMatchingMetadata = this.props.metadata.find(meta => {
      return meta.name.toLowerCase() === this.state.updatedMetadataName.toLowerCase() && meta.id !== this.state.selectedMetadata.id
    })

    if (exactMatchingMetadata) {
      return this.setState({
        updatedMetadataAlreadyExists: true,
        metadataThatAlreadyExists: exactMatchingMetadata,
        updatedMetadataIsExactDuplicate: true,
      })
    }

    const matchingMetadata = this.props.metadata.find(meta => {
      return (meta.name.toLowerCase().includes(this.state.updatedMetadataName.toLowerCase()) ||
      this.state.updatedMetadataName.toLowerCase().includes(meta.name.toLowerCase())) && meta.id !== this.state.selectedMetadata.id
    })

    if (matchingMetadata) {
      return this.setState({
        updatedMetadataAlreadyExists: true,
        metadataThatAlreadyExists: matchingMetadata,
        updatedMetadataIsExactDuplicate: false,
      })
    }

    return this.handleSubmit()
  }


  handleCancelSubmit = () => {
   return this.setState({
     updatedMetadataAlreadyExists: false,
     metadataThatAlreadyExists: null,
     updatedMetadataIsExactDuplicate: false,
     updatedMetadataName: this.state.selectedMetadata ? this.state.selectedMetadata.name : "",
   })
 }


  handleSubmit = () => {
    const { selectedMetadata, updatedMetadataName } = this.state

    if (updatedMetadataName) {

      swal({
        text: "Saving metadata... Please stand by.",
        icon: require("../../../static/images/spinner.gif"),
        button: false
      })

      this.setState({
        updatedMetadataAlreadyExists: false,
        metadataThatAlreadyExists: null,
        updatedMetadataIsExactDuplicate: false,
      })

      axios({
        method: "PATCH",
        url: `${getServerURL()}${this.props.route}/${selectedMetadata.id}/`,
        headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
        data: {
          name: updatedMetadataName,
        }
      })
      .then(response => {
        this.props.editMetadata(response.data)
        swal({
          title: "Success",
          text: "The metadata type " + updatedMetadataName + " has been updated",
          icon: "success",
          button: "Continue",
        })
      })
      .catch(error => {
        const message = "There was an error editing your metadata type"
        handleErrorFetchingData(error, message)
      })
    } else {
      swal({
        title: "Error",
        text: "Please enter a name for the metadata type before saving",
        icon: "error",
        button: "Continue",
      })
    }
  }

  handleDelete = () => {
    const { selectedMetadata } = this.state
    this.toggleShowDeletePopover()

    axios({
      method: "DELETE",
      url: `${getServerURL()}${this.props.route}/${selectedMetadata.id}/`,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
    })
    .then(response => {
      this.props.deleteMetadata(selectedMetadata.id)
      this.setState({ selectedMetadata: '' })
      swal({
        title: "Success",
        text: "The metadata type " + selectedMetadata.name + " has been deleted",
        icon: "success",
        button: "Continue",
      })
    })
    .catch(error => {
      const message = "There was an error deleting your metadata type"
      handleErrorFetchingData(error, message)
    })
  }

  getValuesForModal = () => {
    const { metadataThatAlreadyExists } = this.state

    if (!metadataThatAlreadyExists) {
      return []
    }

    if (metadataThatAlreadyExists && metadataThatAlreadyExists.metadata_values) {
      return metadataThatAlreadyExists.metadata_values
    }

    if (metadataThatAlreadyExists && metadataThatAlreadyExists.proposal_metadata_values) {
      return metadataThatAlreadyExists.proposal_metadata_values
    }
  }


  render() {

    const { updatedMetadataAlreadyExists, metadataThatAlreadyExists, updatedMetadataIsExactDuplicate } = this.state

    return (
      <div id="EditMetadataType">

        {updatedMetadataAlreadyExists ?
          <DuplicateMetadataModal
            show={updatedMetadataAlreadyExists}
            name={metadataThatAlreadyExists ? metadataThatAlreadyExists.name : ""}
            type={metadataThatAlreadyExists ? metadataThatAlreadyExists.type : ""}
            values={this.getValuesForModal()}
            isExactDuplicate={updatedMetadataIsExactDuplicate}
            typeOrValue={"type"}
            projectOrProposal={this.props.selectedModel}
            client={this.props.selectedClient}
            handleSubmit={this.handleSubmit}
            handleCancelSubmit={this.handleCancelSubmit}
          />
          :
          null
        }

        <Row>
          <Col sm={12} md={6}>
            <h5>
              Select a {this.props.selectedModel.toLowerCase()} metadata to edit
            </h5>
            <FormControl
              componentClass="select"
              name="selectedMetadata"
              onChange={this.handleSelect}
              selected={this.state.selectedMetadata}
            >
              <option value=''>
                -
              </option>
              {this.props.metadata.map((meta, index) => {
                return (
                  <option key={meta.id} value={index}>
                    {meta.name}
                  </option>
                )
              })}
            </FormControl>
          </Col>
          <Col sm={12} md={6}>
            {this.state.selectedMetadata ?
              <Fragment>
                <h5>
                  Enter new name
                </h5>
                <FormControl
                  name="updatedMetadataName"
                  value={this.state.updatedMetadataName}
                  onChange={this.handleChange}
                />
              </Fragment>
              :
              null
            }
          </Col>
        </Row>
        {this.state.selectedMetadata ?
          <Row>
            <br/>
            <Col sm={12} md={6}>
              <Button
                onClick={this.checkIfMetadataExists}
                style={{marginRight: '5px'}}
              >
                Save
              </Button>
              <Button
                bsStyle="danger"
                id='deleteMetadataButton'
                onClick={this.toggleShowDeletePopover}
                style={{marginLeft: '5px'}}
              >
                Delete
              </Button>
              <Overlay
                show={this.state.showDeletePopover}
                onHide={this.toggleShowDeletePopover}
                target={document.getElementById('deleteMetadataButton')}
                placement="top"
                rootClose
              >
                <Popover id="deleteMetadataPopover" title="Delete Metadata Type?">
                  Are you sure you want to delete {this.state.selectedMetadata.name}?
                  <br/>
                  <br/>
                  This metadata type and <strong>all of its associated data will be permanently removed from the database.</strong>
                  <br/>
                  <br/>
                  <strong>
                    This action cannot be undone.
                  </strong>
                  <br/>
                  <br/>
                  <center>
                    <Button
                      bsStyle="danger"
                      onClick={this.handleDelete}
                      style={{marginRight: '5px'}}
                    >
                      Delete
                    </Button>
                    <Button
                      onClick={this.toggleShowDeletePopover}
                      style={{marginLeft: '5px'}}
                    >
                      Cancel
                    </Button>
                  </center>
                </Popover>
              </Overlay>

            </Col>
          </Row>
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    // metadata: state.manageProjects.metadata,
  }
}

export default connect(mapStateToProps, { editMetadata })(EditMetadataType)



// WEBPACK FOOTER //
// ./src/routes/manager/components/EditMetadataType.js